import logo from './logo.svg';
// import ProtectedRoute from './ProtectedRoute';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Home from './Home';
import User from './User';
import Technology from './Technology';
import ContactUs from './ContactUs';
import './App.css';
import Header from './Header';
import AuthenticityCheck from './AuthenticityCheck';
import Ecosystem from './Ecosystem';
import Mobile from './Mobile';
import { useEffect } from 'react';

function App() {
    // const navigate = useNavigate();
    // useEffect(() => {
    //   const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    //   if (isMobile && window.location.pathname !== '/mobile') {
    //     navigate('/mobile');
    //   }
    // }, [navigate]);
  return (
    <div className="App">
      <div className="route">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/user' element={<User />} />
            <Route path='/partner' element={<Technology />} />
            <Route path='/contactus' element={<ContactUs />} />
            <Route path='/header' element={<Header />} />
            <Route path='/authenticity-check' element={<AuthenticityCheck />} />
            <Route path='/ecosystem' element={<Ecosystem />} />
            <Route path='/mobile' element={<Mobile />} />
          </Routes>    
      </div>
    </div>
  );
}

export default App;
